// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OptionalConsents-module-radioGroupLabel-2BzEh{color:#5c615e;font-weight:400;margin-top:15px;margin-bottom:4px}.OptionalConsents-module-radioGroup-h5wDm{display:flex;flex-direction:row;margin-inline-start:12px}.OptionalConsents-module-radioLabel-iU6hf{margin-inline-end:25px}.OptionalConsents-module-consentSectionsContainer-2Vm-A{display:flex;flex-direction:column;gap:32px;gap:var(--des-dimension-gap-and-padding-general-away-x-large, 32px)}.OptionalConsents-module-actions-2OSSF{margin-top:var(--des-spacing-form-vertical-between-field-2xs)}@media(min-width: 768px){.OptionalConsents-module-actions-2OSSF{margin-top:var(--des-spacing-form-vertical-between-field-sl)}}", ""]);
// Exports
exports.locals = {
	"radioGroupLabel": "OptionalConsents-module-radioGroupLabel-2BzEh",
	"radioGroup": "OptionalConsents-module-radioGroup-h5wDm",
	"radioLabel": "OptionalConsents-module-radioLabel-iU6hf",
	"consentSectionsContainer": "OptionalConsents-module-consentSectionsContainer-2Vm-A",
	"actions": "OptionalConsents-module-actions-2OSSF"
};
module.exports = exports;
